var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.11111,
    y: 1.11111,
    width: 17.7778,
    height: 17.7778,
    rx: 8.88889,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.11111,
    y: 1.11111,
    width: 17.7778,
    height: 17.7778,
    rx: 8.88889,
    stroke: "white",
    strokeWidth: 2.22222
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.62006 8.12266C7.83488 8.03377 8.0571 7.93377 8.28673 7.82266C8.52377 7.70414 8.7534 7.57821 8.97562 7.44488C9.19784 7.30414 9.40895 7.15969 9.60895 7.01154C9.81636 6.85599 10.0015 6.69303 10.1645 6.52266H11.3201V14.2227H9.66451V8.67821C9.44228 8.82636 9.19414 8.9634 8.92006 9.08932C8.64599 9.20784 8.37932 9.31155 8.12006 9.40043L7.62006 8.12266Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle1);
export default __webpack_public_path__ + "static/media/circle_1.801e8fd179cb2f8112937d1a7fecd89d.svg";
export { ForwardRef as ReactComponent };